import type { IconSvgObject } from './types';

const Heading02Icon: IconSvgObject = [
  ["path", { d: "M20 19H16C16 18.4046 16.1523 17.8477 16.5858 17.4142L19.3787 14.6213C19.8177 14.1823 20 13.6088 20 13C20 11.8954 19.1046 11 18 11C16.8954 11 16 11.8954 16 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12H13M4 19V5M13 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading02Icon;
